/*
 * MySiteCare
 *
 * Copyright © 2026 Jeanjen Sisoy Luberio
 * doing business as MySiteCare Website Application Services.
 * All rights reserved.
 *
 * DTI Business Name No. 7934250
 * https://mysitecare.eu
 *
 * This file contains original proprietary MySiteCare source code,
 * except for third-party components identified under their
 * respective licenses.
 */
// INTERNAL TEST FIXTURE (Phase C repair-pipeline demonstration) — never real
// customer-facing code. Fixed by the Phase C repair pipeline: null-guards `user` so a
// missing prop renders a safe fallback instead of throwing.
export default function RepairCanaryComponent({ user }) {
  return <div data-testid="repair-canary-output">{user?.name?.toUpperCase() || "GUEST"}</div>;
}
